// WU-2.2 — list hook for /admin/queue-instructions (useQueueBlocks pattern).
import { useCallback, useEffect, useState } from "react";
import { queueInstructionsApi, type QueueInstructionRecord } from "../api/client";

export function useQueueInstructions() {
  const [instructions, setInstructions] = useState<QueueInstructionRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const result = await queueInstructionsApi.list();
      setInstructions(result.instructions);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return { instructions, loading, error, refetch };
}
